export const LIST_DISCIPLINES = /* GraphQL */ `
  query ListDisciplines {
    listDisciplines {
      group
      label
      value
    }
  }
`;

/**
 * Keep errorPolicy "all" so a single bad row does not blank the whole discipline list.
 * Discipline.value is String in the API so DynamoDB slugs always serialize.
 */
export const LIST_DISCIPLINES_QUERY_OPTIONS = { errorPolicy: "all" };
